export default {
    url: '',
    template: '<courses-courses-edit-version-list course="vm.course" can-manage-course="vm.canManageCourse" />',
    controller (course, CourseService) {
        this.course = course;
        this.canManageCourse = CourseService.canManageCourse(course);
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/courses/edit/version/list/index.js